import React, { InputHTMLAttributes, useMemo, forwardRef } from 'react';
import './Input.scss';
import { ReactComponent as Hide } from 'img/icon-hide.svg';
import { ReactComponent as Show } from 'img/icon-show.svg';
import { ReactComponent as Search } from 'img/icon_search.svg';
import { ReactComponent as ID } from 'img/icon-id.svg';
import { ReactComponent as LOCK } from 'img/icon-lock.svg';

export interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  id?: string;
  type?: 'text' | 'email' | 'password' | 'number' | 'search' | 'id';
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showPassword?: boolean;
  onTogglePassword?: () => void;
}

const Input = forwardRef<HTMLInputElement, InputProps>((
  {
    id,
    type = 'text',
    placeholder = '',
    className = '',
    disabled = false,
    error = false,
    value,
    onChange,
    showPassword = false,
    onTogglePassword,
    ...rest
  },
  ref
) => {
  const inputType = useMemo(() => {
    if (type === 'password') {
      return showPassword ? 'text' : 'password';
    } else if (type === 'search') {
      return 'text';
    }
    return type;
  }, [type, showPassword]);

  return (
    <div
      className={`container ${className} ${type === 'password' ? 'container-password' : ''} ${error ? 'error' : ''}`}
      // onKeyDownCapture={(e) => e.stopPropagation()}
      // onKeyUpCapture={(e) => e.stopPropagation()}
    >
      {type === 'search' && (
        <span className="container-search-svg">
          <Search />
        </span>
      )}

      {type === 'id' && (
        <span className="container-search-svg">
          <ID />
        </span>
      )}

      {type === 'password' && (
        <span className="container-search-svg">
          <LOCK />
        </span>
      )}

      <input
        id={id}
        type={inputType}
        placeholder={placeholder}
        className={`container-input`}
        disabled={disabled}
        value={value}
        onChange={onChange}
        onKeyDown={(e) => e.stopPropagation()}
        onKeyUp={(e) => e.stopPropagation()}
        ref={ref}
        {...rest}
      />

      {type === 'password' && !disabled && (
        <span
          className="container-password-svg"
          onClick={onTogglePassword}
          data-testid="svg-test"
        >
          {showPassword ? <Show /> : <Hide />}
        </span>
      )}
    </div>
  );
})

export default Input;
